'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPageSizes = undefined;

var _types = require('./types');

var defaultPageSizes = exports.defaultPageSizes = [10, 25, 50, 100, _types.AllItemsPerPage];


//////////////////
// WEBPACK FOOTER
// ./~/react-formio/lib/constants.js
// module id = 598
// module chunks = 0